goog.provide('el8.ptdata.confidentialItems');

goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.model.base');
goog.require('el8.service.urls');


(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('description', true);
    _class.addIntProperty('rank');

    el8.ptdata.confidentialItems = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('confidentialItems'); },
        sortFn: function(a, b){ return a.getRank()-b.getRank(); },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};

            if (item.getId()) {
                el8.appservice.notifier.notify('Updating confidential item...');
            } else {
                el8.appservice.notifier.notify('Saving new confidential item...');
            }
            
            $.el8_ajax({
                type: 'POST',
                async: opts.async,
                url: el8.service.urls.get('confidentialItems', [item.getId()]),
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.confidentialItems.remove(item, true); // updates come down with a new id
                    }
                    item.populate(data.item);
                    el8.appservice.notifier.notify('Confidential item saved.');
                    if( successCb ) { successCb(item); }
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                async: opts.async,
                url: el8.service.urls.get('confidentialItems', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });

    // return that;

})();

